export default __webpack_public_path__ + "img/8e2b6b9852ef961d6cc625d106ac3d3c.png";